import React from "react";
import { Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { capitalize } from "lodash";
import { LuExternalLink } from "react-icons/lu";

/**
 * Reusable TaskDrawer Header Component
 * @param {object} props
 * @param {string} props.title - Title to display (e.g., "Edit Task")
 * @param {object} props.leadData - Lead information
 * @param {string} props.leadData.fullName - Lead full name
 * @param {string} props.leadData.id - Lead ID
 * @param {function} props.onLinkClick - Handler for link click
 * @param {function} props.onClose - Handler for close button (optional)
 * @param {boolean} props.showCloseButton - Whether to show close button (default: false)
 */
const TaskDrawerHeader = ({
  title = "Edit task",
  leadData,
  onLinkClick,
  onClose,
  showCloseButton = false,
}) => {
  const renderLeadInfo = () => {
    return (
      <div className="flex items-center gap-2">
        <Typography.Text type="secondary" className="!text-[#000000A6] text-sm">
          Lead name: {leadData?.fullName || "N/A"}
        </Typography.Text>
        {onLinkClick && leadData?.id && (
          <div className="mt-1 cursor-pointer" onClick={() => onLinkClick(leadData.id)}>
            <LuExternalLink className="text-twLinkColor" />
          </div>
        )}
      </div>
    );
  };

  const renderCloseButton = () => {
    if (!showCloseButton || !onClose) return null;

    return <CloseOutlined className="cursor-pointer" onClick={onClose} />;
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col">
        <Typography.Title className="!mb-0" level={5} strong>
          {title}
        </Typography.Title>
        {renderLeadInfo()}
      </div>
      {renderCloseButton()}
    </div>
  );
};

export default TaskDrawerHeader;
